import RepaymentsCalculatorModule from './RepaymentsCalculator.module';

export * from './RepaymentsCalculatorModuleProps';
export default RepaymentsCalculatorModule;
